import React, { useState, useEffect } from "react";
import { SensorTypesDataContext } from "./context";

import { getSensorTypes } from "../services/services";

const SensorTypesProvider = ({ children }) => {
  const [SensorTypesData, setSensorTypesData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setSensorTypesData([]);
    const fetchSensorTypes = async () => {
      const SensorTypes = await getSensorTypes({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });

      const tempSensorTypes = [
        // {
        //   id: "122",
        //   title: "Υποδομές ΑΜΕΑ",
        // },
        // {
        //   id: "1",
        //   title: "Περιβαλλοντικά Δεδομένα",
        // },
        // {
        //   id: "8",
        //   title: "Δρομολόγια Απορριμματοφόρων",
        // },
        // {
        //   id: "9",
        //   title: "Πληρότητα κάδων",
        // },
        // // {
        //   id: "10",
        //   title: "Υδρόμετρα",
        // },
        // {
        //   id: "12",
        //   title: "Κατανάλωση Eνέργειας",
        // },
        // {
        //   id: "24",
        //   title: "Αισθητήρες Στάθμευσης",
        // },
      ];

      for (let item of SensorTypes) {
        tempSensorTypes?.push({
          id: item.sensortype_id,
          title: item.sensortype_name,
        });
      }

      setSensorTypesData(tempSensorTypes);
    };

    fetchSensorTypes();
  }, []);

  return (
    <SensorTypesDataContext.Provider
      value={{ SensorTypesData, setSensorTypesData, loading, error }}
    >
      {children}
    </SensorTypesDataContext.Provider>
  );
};

export default SensorTypesProvider;
